export const Types = {
    SAVE_MACHINE_DATA: "SAVE_MACHINE_DATA",
    USER_DETAILS: "USER_DETAILS",
    ACTIVE_SUBSTAGE: "ACTIVE_SUBSTAGE"
};